module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_riemenstalden-ebaed76c3db5fc21e1a0e0ae53ae2337.png";